/* eslint-disable max-len */
import { PlusOutlined, SaveOutlined } from '@ant-design/icons';
import {
  Breadcrumb, Button, Form, Input, Select, Card, Row, Col,
} from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import { PlusOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';

import styles from './CreateDevices.module.less';
import useCreateDevices from './useCreateDevices';

function CreateDevices() {

  const { t } = useTranslation();
  const {
    onFinishFailed, onFinish,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditDevice,
    businessType,
    deviceType,
    dataGateway,
    loadingSave,
    handleDeviceHome,
    form,
    onData,
  } = useCreateDevices();
  const businessTypeInfo = useSelector(({ telemetry: tel }) => tel.generalBusinessTypeInfo);
  const ExpRegSoloNumeros="^[0-9]+$";

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Form
          form={form}
          name="CreateDevice"
          layout="vertical"
          initialValues={{
            ...dataForm, remenber: true,
          }}
          values={{ name: 'jhon', client: 'example', state: 'normal' }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={formOnValuesChange}
          autoComplete="off"
        >
          <Card style={{ width: '100%', marginBottom: '1rem' }}>
            <Row>
              <Col  xs={{span: 24}}  sm={{span: 24}}  md={{span: 20}}  lg={{span: 20}}  xl={{span: 20}}
              >
                <div className={styles.section_title}>{idToEdit?t('views.create_devices.edit_device'):t('views.create_devices.new_device')}</div>
                <Breadcrumb className={styles.date_wrapper}>
                  { businessTypeInfo.name
                    ? (
                      <>
                        <Breadcrumb.Item className={styles.breadcrumb}>
                          <Link to="/tablero-general">Home</Link>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item className={styles.breadcrumb}>
                          <a onClick={handleDeviceHome}>
                            {businessTypeInfo && businessTypeInfo.name || 'Business'}
                          </a>
                        </Breadcrumb.Item>
                      </>
                    )
                    : (
                      <>
                        <Breadcrumb.Item className={styles.breadcrumb}>
                          <Link to="/dispositivos/administrar">{t('menu_items.main.devices')}</Link>
                        </Breadcrumb.Item>
                      </>
                    )}

                  {(idToEdit)
                    ? (
                      <>
                        <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.devices_edit')}</Breadcrumb.Item>
                        <Breadcrumb.Item className={styles.breadcrumb}>{dataForm && dataForm.name}</Breadcrumb.Item>
                      </>
                    )
                    : <Breadcrumb.Item className={styles.breadcrumb}>{t('views.create_devices.new_device')}</Breadcrumb.Item>}
                </Breadcrumb>
              </Col> 

              <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}
                className={styles.column_btn}
              > 
                <Button onClick={cancelCreateEditDevice}>X</Button>

                <Button key="button"  className='m_l' type="primary" loading={loadingSave} htmlType="submit" icon={(!idToEdit) ?<PlusOutlined />:null} >
                 {(!idToEdit) ? t('views.create_business_type.buttons.create') : t('views.create_business_type.buttons.update') }
                </Button> 

              </Col>


            </Row>
          </Card>

          <Card style={{ width: '100%' }}>
            <div className={styles.containerForm}>
              <Row gutter={[16, 8]}>

                <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 24,order: 1, }} lg={{span: 12,order: 1, }} xl={{   span: 12,   order: 1, }}
                >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_devices.form.name')}
                    name="name"
                    rules={[
                      { required: true, message: t('views.create_devices.form.name_message') }
                    ]}
                  >
                    <Input className={styles.input} placeholder={t('views.create_devices.form.name_place_holder')} />
                  </Form.Item>
                </Col>

                <Col  xs={{span: 24,order: 2,  }}  sm={{span: 24,order: 2,  }}  md={{span: 24,order: 2,  }}  lg={{span: 12,order: 3,  }}  xl={{    span: 12,    order: 3,  }}
                >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_devices.form.client')}
                    name="client"
                    rules={[{ required: true, message: t('views.create_devices.form.client_message') }]}
                  >
                    <Input className={styles.input} placeholder={t('views.create_devices.form.client_place_holder')} />
                  </Form.Item>
                </Col>

                <Col xs={{span: 24,order: 6, }} sm={{span: 24,order: 6, }} md={{span: 24,order: 6, }} lg={{span: 12,   order: 6, }} xl={{   span: 12,   order: 6, }}
                >
                  <Form.Item
                        className={styles.label}
                        label={t('views.create_devices.form.business')}
                        name="business_type_id"
                        rules={[{ required: true, message: t('views.create_devices.form.business_message') }]}
                      >
                        <Select 
                            onChange={(value) => onData(value)} 
                            className={styles.select} 
                            showSearch
                            optionFilterProp="children" 
                            filterOption={(input, option) =>
                              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={businessType}
                        >
                          {/*businessType.map((business) => (
                            <Select.Option key={business.id} value={business.id}>{business.name}</Select.Option>
                          ))*/}
                        </Select>
                      </Form.Item>
                </Col>
                
                <Col xs={{span: 24,order: 6, }} sm={{span: 24,order: 6, }} md={{span: 24,order: 6, }} lg={{span: 12,order: 6, }} xl={{span: 12,order: 6, }}
                >
                    <Form.Item
                      className={styles.label}
                      label={t('views.create_devices.form.device_type')}
                      name="device_type_id"
                      rules={[{ required: true, message: t('views.create_devices.form.device_type_message') }]}
                    >
                      <Select 
                        mode="multiple" 
                        showSearch
                        optionFilterProp="children" 
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        options={deviceType}
                      >
                        {/*deviceType.map((device) => (
                          <Select.Option key={device.id} value={device.id}>{device.name}</Select.Option>
                        ))*/}
                      </Select>
                    </Form.Item>
                </Col>
                
                <Col xs={{span: 24,order: 6, }} sm={{span: 24,order: 6, }} md={{span: 24,order: 6, }} lg={{span: 12,   order: 6, }} xl={{   span: 12,   order: 6, }}
                >
                     <Form.Item
                        className={styles.label}
                        label={t('views.create_devices.form.slvdl')}
                        name="slvId"
                        rules={[{ required: true, message: t('views.create_devices.form.slvdl_message') },
                                {
                                  validator: (_, value) =>
                                    value && value.match(ExpRegSoloNumeros)!=null
                                      ? Promise.resolve()
                                      : Promise.reject(new Error(t('views.dynamic_device_types_create_edit.feedbacks.required_input_number'))),
                                }
                              ]}
                      >
                        <Input className={styles.input} placeholder={t('views.create_devices.form.slvdl_place_holder')} />
                      </Form.Item>
                </Col>

                <Col xs={{span: 24,order: 6, }} sm={{span: 24,order: 6, }} md={{span: 24,order: 6, }} lg={{span: 12,   order: 6, }} xl={{   span: 12,   order: 6, }}
                >
                    <Form.Item
                      className={styles.label}
                      label={t('views.create_devices.form.gateway')}
                      name="gateway_id"
                      rules={[{ required: true, message: t('views.create_devices.form.gateway_message') }]}
                    >
                       <Select 
                          className={styles.select}
                          showSearch
                          optionFilterProp="children" 
                          filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                          }
                          options={dataGateway}
                       >

                        {/*dataGateway.map((gateway) => (
                          <Select.Option key={gateway.id} value={gateway.id}>{gateway.name}</Select.Option>
                        ))*/}
                      </Select>
                    </Form.Item>
                </Col>
                

              </Row>
            </div>
          </Card>
        </Form>
      </div>
    </MainLayout>
  );

}

export default withAuth(CreateDevices);
